<template>
  <template
    v-for="(option, idx) in options"
    :key="option?.text || idx"
  >
    <div
      v-if="option"
      :class="{
        'fact-finder-text-filter-fi': true,
        'fact-finder-text-filter-fi--active': option.selected,
        'fact-finder-text-filter-fi--disabled': option.disabled,
      }"
      @click="toggleOption(option)"
    >
      <icon-fi
        :icon="option.selected ? 'checkbox-checked-filled' : 'checkbox-empty-filled'"
        class="fact-finder-text-filter-fi__icon"
      />
      <div class="fact-finder-text-filter-fi__text">
        <!-- keep the label in an element: a translator replaces a bare text node and Vue then patches a detached node -->
        <span>{{ option.text }}</span> <span v-if="filter.unit">{{ filter.unit }}</span>
        <span
          v-if="!option.selected && option.totalHits"
          class="fact-finder-text-filter-fi__total"
        >
          ({{ option.totalHits }})
        </span>
      </div>
    </div>
  </template>
</template>

<script setup lang="ts">
import { IconFi } from 'atoms';
import { computed } from 'vue';

import type {
  ProcessedFactFinderNgFacet,
  ProcessedFactFinderNgFacetElement,
} from '@/components/facets/processedFacetTypes';

import type { SearchFilter } from '../../SearchFactFinderResultsFi.vue';

defineOptions({
  name: 'FactFinderTextFilterFi',
});

const emits = defineEmits<{
  'filter-changed': [filter: SearchFilter];
}>();

const props = defineProps<{
  filter: ProcessedFactFinderNgFacet;
}>();

const options = computed(() => props.filter.elements);

const toggleOption = (option: ProcessedFactFinderNgFacetElement) => {
  if (option.disabled) {
    return;
  }

  emits('filter-changed', {
    value: !option.selected,
    element: {
      name: option.text || '',
      associatedFieldName: option.associatedFieldName || '',
      selected: !option.selected,
    },
  });
};
</script>

<style scoped src="./fact-finder-text-filter-fi" />
